var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HomeView"},[_c('Head'),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":4}},[_c('LeftBody')],1),_c('el-col',{attrs:{"span":20}},[_c('RightBody')],1)],1),_c('Footer',{attrs:{"email":_vm.email,"filing":_vm.filing}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }